const PARENT_SELECTOR = '.js-facet-filter-parent';

const getButtons = (group) => Array.from(group.querySelectorAll('.js-facet-filter'));
const getActiveButtons = (group) => getButtons(group).filter((button) => button.classList.contains('is-active'));

const createFacetFilter = (parentEl) => {
	const items = Array.from(parentEl.querySelectorAll('.js-item'));
	const groups = Array.from(parentEl.querySelectorAll('.filter-group'));
	const loadMoreBtn = parentEl.querySelector('.js-load-more');
	const noResultsEl = parentEl.querySelector('.js-no-results');
	const activeFiltersEl = parentEl.querySelector('.js-active-filters');
	const activeFiltersList = parentEl.querySelector('.js-active-filters-list');
	const resetBtn = parentEl.querySelector('.js-facet-reset');
	const removeLabel = activeFiltersEl ? activeFiltersEl.dataset.removeLabel : '';
	const initialCount = loadMoreBtn ? parseInt(loadMoreBtn.dataset.count, 10) : items.length;
	let count = initialCount;
	let filteredItems = items;

	const updateItemDisplay = () => {
		items.forEach((item) => {
			item.style.display = 'none';
		});
		filteredItems.forEach((item, index) => {
			item.style.display = index < count ? 'block' : 'none';
		});

		if (loadMoreBtn) {
			loadMoreBtn.style.display = count >= filteredItems.length ? 'none' : 'flex';
		}

		if (noResultsEl) {
			noResultsEl.style.display = filteredItems.length === 0 ? 'block' : 'none';
		}
	};

	const updateActiveFiltersBar = () => {
		let hasActive = false;

		groups.forEach((group) => {
			const activeButtons = getActiveButtons(group);
			const countEl = group.querySelector('.js-facet-count');
			if (countEl) {
				countEl.textContent = activeButtons.length;
				countEl.classList.toggle('is-visible', activeButtons.length > 0);
			}
		});

		if (!activeFiltersEl || !activeFiltersList) return;

		activeFiltersList.innerHTML = '';

		groups.forEach((group) => {
			getActiveButtons(group).forEach((button) => {
				hasActive = true;

				const chip = document.createElement('span');
				chip.className = 'active-filters__chip';

				const label = document.createElement('span');
				label.textContent = button.dataset.label || button.textContent.trim();
				chip.appendChild(label);

				const remove = document.createElement('button');
				remove.type = 'button';
				remove.setAttribute('aria-label', removeLabel);
				remove.textContent = '×';
				remove.addEventListener('click', () => {
					button.classList.remove('is-active');
					applyFilters();
				});
				chip.appendChild(remove);

				activeFiltersList.appendChild(chip);
			});
		});

		activeFiltersEl.classList.toggle('is-visible', hasActive);
	};

	const applyFilters = () => {
		filteredItems = items.filter((item) => groups.every((group) => {
			const selected = getActiveButtons(group).map((button) => button.dataset.value);
			if (selected.length === 0) return true;

			const taxonomy = group.dataset.taxonomy;
			const itemValues = (item.dataset[taxonomy] || '').split(',').filter(Boolean);
			return selected.some((value) => itemValues.includes(value));
		}));

		count = initialCount;
		updateItemDisplay();
		updateActiveFiltersBar();
	};

	groups.forEach((group) => {
		getButtons(group).forEach((button) => {
			button.addEventListener('click', () => {
				button.classList.toggle('is-active');
				applyFilters();
			});
		});

		const trigger = group.querySelector('.js-facet-trigger');
		const panel = group.querySelector('.js-facet-panel');
		if (trigger && panel) {
			trigger.addEventListener('click', (event) => {
				event.stopPropagation();
				const isOpen = group.classList.contains('is-open');

				groups.forEach((otherGroup) => {
					otherGroup.classList.remove('is-open');
					const otherTrigger = otherGroup.querySelector('.js-facet-trigger');
					if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
				});

				if (!isOpen) {
					group.classList.add('is-open');
					trigger.setAttribute('aria-expanded', 'true');
				}
			});
		}
	});

	document.addEventListener('click', (event) => {
		groups.forEach((group) => {
			if (!group.contains(event.target)) {
				group.classList.remove('is-open');
				const trigger = group.querySelector('.js-facet-trigger');
				if (trigger) trigger.setAttribute('aria-expanded', 'false');
			}
		});
	});

	if (resetBtn) {
		resetBtn.addEventListener('click', () => {
			groups.forEach((group) => {
				getButtons(group).forEach((button) => button.classList.remove('is-active'));
			});
			applyFilters();
		});
	}

	if (loadMoreBtn) {
		loadMoreBtn.addEventListener('click', () => {
			count += initialCount;
			updateItemDisplay();
		});
	}

	// Pre-select filters coming from a link like /loesungen/?branche=slug
	const params = new URLSearchParams(window.location.search);
	let hasPreselection = false;
	groups.forEach((group) => {
		const value = params.get(group.dataset.taxonomy);
		if (!value) return;

		const button = getButtons(group).find((btn) => btn.dataset.value === value);
		if (button) {
			button.classList.add('is-active');
			hasPreselection = true;
		}
	});

	if (hasPreselection) {
		applyFilters();
	}
	else {
		updateItemDisplay();
		updateActiveFiltersBar();
	}
};

export const initFacetFilters = () => {
	const parents = document.querySelectorAll(PARENT_SELECTOR);
	if (parents.length === 0) return;

	parents.forEach(createFacetFilter);
};
